import React from "react";
import Router from "next/router";
import moment from "moment";
import { Button, Modal } from "antd";
import { get } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { translate } from "$ACTIONS/Translate";
//自我限制彈窗
class SelfExclusionModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ModalOpen: false,
        };
    }
    componentDidMount() {
        const isLogin = localStorage.getItem("access_token");

        if (isLogin) {
            if (this.props.ModalType == 2) {
                this.setModalOpen();
            } else {
                this.SelfExclusions();
            }
        }
        this.CallWindow(false);
    }

    CallWindow(status) {
        window.SelfExclusionsisDisabled = status;
        window.CheckSelfExclusions = (status) => this.setModalStatuas(status);
    }

    SelfExclusions() {
        get(ApiPort.GETSelfExclusions).then((res) => {
            if (res && res.result) {
                console.log("selfExclusion res: ", res);

                const isDisabled =
                    res.result.status &&
                    (res.result.disableDeposit ||
                        res.result.disableFundIn ||
                        res.result.disableBetting);

                if (isDisabled) {
                    this.CallWindow(true);

                    this.setState({
                        isDisabled: true,
                        SelfExclusionsData: res.result,
                    });

                    if (
                        this.props.ModalType == 1 &&
                        this.props.OpenModalUrl == "Deposit"
                    ) {
                        this.setModalOpen();
                    }
                } else {
                    this.CallWindow(false);
                }
            }
        });
    }

    setModalStatuas = () => {
        if (this.state.isDisabled) {
            this.setModalOpen();
        }
    };

    setModalOpen = () => {
        this.setState({ ModalOpen: true });
    };

    render() {
        let setupDate = "xx/xx/xxxx";
        let dateDuration = `(${translate("永久")})`;
        if (this.state.SelfExclusionsData) {
            setupDate = moment(
                this.state.SelfExclusionsData.selfExcludeSetDate + "+08:00"
            ).format("DD/MM/YYYY");
            if (this.state.SelfExclusionsData.selfExclusionSettingID == 3) {
                dateDuration = `(${translate("永久")})`;
            } else {
                dateDuration =
                    this.state.SelfExclusionsData.selfExcludeDuration;
            }
        }

        return (
            <Modal
                closable={false}
                className="commonModal SelfExclusionModal"
                title={null}
                visible={this.state.ModalOpen}
                width="440px"
                footer={null}
                centered={true}
            >
                <div className="SelfExclusionModalContent">
                    <h3>{translate("自我限制")}</h3>
                    <div className="SelfExclusionModalText">
                    <div>Bạn đã thiết lập thành công</div>
                    <div>
                        {`Tự loại trừ trong ${dateDuration} ngày vào`}
                    </div>
                    <div>
                        {setupDate}
                    </div>
                    <div>Nếu bạn cần bất kỳ trợ giúp nào</div>
                    <div>Vui lòng liên hệ Live Chat</div>
                    </div>
                </div>
                <div
                className="SelfExclusionModalButtonGroup"
                >
                <Button
                    className="SelfExclusionModalButton"
                    onClick={() => {
                        this.setState({ ModalOpen: false }, () => {
                            this.props.afterCloseModal &&
                                this.props.afterCloseModal();
                        });
                        PopUpLiveChat();
                    }}
                >
                    {"Live Chat"}
                </Button>
                <Button
                    className="SelfExclusionModalButton"
                    onClick={() => {
                        this.setState({ ModalOpen: false }, () => {
                            this.props.afterCloseModal &&
                                this.props.afterCloseModal();
                        });
                    }}
                >
                    {translate("明白了")}
                </Button>

                </div>
            </Modal>
        );
    }
}

export default SelfExclusionModal;
